<div class="badge-container" [class.rejected]="rejected" [class.waitingSigns]="waitingSigns" [class.analysis]="analysis"
    [class.homologation]="homologation" [class.blocked]="blocked" [class.finished]="finished">
    {{label}}
</div>
